import { injectable } from 'inversify';
import { action, makeObservable, observable } from 'mobx';

export interface IFirstClientMountService {
  isFirstClientMount: boolean;
  setIsFirstClientMount: (isFirstClientMount: boolean) => void;
}

@injectable()
export class FirstClientMountService implements IFirstClientMountService {
  @observable
  isFirstClientMount = true;

  @action.bound
  setIsFirstClientMount(isFirstClientMount: boolean) {
    this.isFirstClientMount = isFirstClientMount;
  }

  constructor() {
    makeObservable(this);
  }
}
